/**
 * AI Testing — combines Playground and Evaluations under one page with sub-tabs.
 *
 *   /admin/ai-testing          — redirects to /admin/ai-testing/playground
 *   /admin/ai-testing/playground   — ad-hoc prompt testing through live routing
 *   /admin/ai-testing/evaluations  — structured benchmark suites with scoring
 */
import { type JSX } from 'react'
import { FlaskConical, Sparkles } from 'lucide-react'
import { NavLink, Navigate, Outlet } from 'react-router'
import RequirePermission from '../../components/auth/RequirePermission.js'

const SUB_TABS = [
  {
    to: '/admin/ai-testing/playground',
    label: 'Playground',
    icon: <Sparkles className="h-3.5 w-3.5" />,
    description: 'Send a prompt through live model routing and inspect the response',
  },
  {
    to: '/admin/ai-testing/evaluations',
    label: 'Evaluations',
    icon: <FlaskConical className="h-3.5 w-3.5" />,
    description: 'Run benchmark suites with automated scoring against expected outputs',
  },
] as const

export function AiTestingLayout(): JSX.Element {
  return (
    <RequirePermission permission="admin:extensions:view">
      <div className="space-y-5">
        {/* Sub-tab nav */}
        <div className="flex gap-1 border-b border-gray-200">
          {SUB_TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `flex items-center gap-1.5 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-[#3454cf] text-[#3454cf]'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`
              }
            >
              {tab.icon}
              {tab.label}
            </NavLink>
          ))}
        </div>

        <Outlet />
      </div>
    </RequirePermission>
  )
}

export function AiTestingRedirect(): JSX.Element {
  return <Navigate to="/admin/ai-testing/playground" replace />
}
